import { Button } from "primereact/button";
import { Column } from "primereact/column";
import { confirmDialog } from "primereact/confirmdialog";
import { DataTable } from "primereact/datatable";
import { Panel } from "primereact/panel";
import { useState } from "react";
import { deleteAnaliseGeral } from "../../../../../../service/Rag/lançamento";
import ModalAnaliseGeralSeplag from "./ModalAnaliseGeralSeplag";

const AnaliseGeralSeplag = ({ setAtualizarData, ListaAnalisePrograma, dadosItemPrograma, permissionUser }) => {
  const [panelCollapsed, setPanelCollapsed] = useState(true);
  const [visibleModal, setVisibleModal] = useState(false);
  const [actionModal, setActionModal] = useState({
    edit: false,
    disbled: false,
    create: false,
  });
  const [dataRow, setDataRow] = useState([]);
  const actionTemplate = (node) => {
    let buttonEditar;
    let buttonVer;
    let buttonDelete;
    if (permissionUser.edit === true) {
      buttonEditar = (
        <Button
          className="p-button-warning button-margin-left p-button p-component p-button-icon-only"
          style={{ marginRight: ".5em" }}
          onClick={() => {
            editarAnaliseGeralSeplag(node);
          }}
        >
          <i className="pi pi-pencil"></i>
        </Button>
      );
      buttonDelete = (
        <Button
          className="p-button-danger button-margin-left p-button p-component p-button-icon-only"
          onClick={() => {
            confirm(node);
          }}
        >
          <i className="pi pi-trash"></i>
        </Button>
      );
    }
    if (permissionUser.view === true) {
      buttonVer = (
        <Button
          className="p-button-info p-button p-component p-button-icon-only"
          onClick={() => {
            vizualizarAnaliseGeral(node);
          }}
          style={{ marginRight: ".5em" }}
        >
          <i className="pi pi-search"></i>
        </Button>
      );
    }

    return (
      <div className="formgroup-inline">
        <div className="field-checkbox">
          {buttonEditar}
          {buttonVer}
          {buttonDelete}
        </div>
      </div>
    );
  };
  const confirm = (_data) => {
    confirmDialog({
      message: "Deseja realmente excluir?",
      header: "Confirmação de exclusão",
      icon: "pi pi-exclamation-triangle",
      acceptLabel: "Sim",
      rejectLabel: "Não",
      accept: () => deleteGeralSeplag(_data),
      reject: () => {},
    });
  };
  const vizualizarAnaliseGeral = (_data) => {
    setDataRow(_data);
    setVisibleModal(true);
    setActionModal({
      edit: false,
      disabled: true,
      create: false,
    });
  };
  const editarAnaliseGeralSeplag = (_data) => {
    setDataRow(_data);
    setVisibleModal(true);
    setActionModal({
      edit: true,
      disabled: false,
      create: false,
    });
  };

  const deleteGeralSeplag = async (_data) => {
    await deleteAnaliseGeral(_data.idenAnalisePrograma).then((_res) => {
      window.$toast.current.show({
        severity: "success",
        summary: "Ação Efetuada",
        detail: "Deletado com Sucesso",
        life: 5000,
      });
      setAtualizarData(true);
    });
  };

  const onAdicionarDado = () => {
    setDataRow([]);
    setVisibleModal(true);
    setActionModal({
      edit: false,
      disbled: false,
      create: true,
    });
  };
  const header = () => {
    if (permissionUser.edit === true) {
      return (
        <div className="table-header">
          <Button
            onClick={() => {
              onAdicionarDado();
            }}
            className="p-button-info p-button p-component p-button-icon-only"
          >
            <i className="pi pi-plus-circle"></i>
          </Button>
        </div>
      );
    }
  };
  return (
    <>
      <Panel
        header="Análise Geral do Programa pela equipe Central da SEPLAG"
        toggleable
        collapsed={panelCollapsed}
        onToggle={(e) => setPanelCollapsed(e.value)}
      >
        <DataTable
          header={header}
          emptyMessage="Nenhum registro encontrado"
          showGridlines
          value={ListaAnalisePrograma}
          dataKey="idenAnalisePrograma"
        >
          <Column body={actionTemplate} header="Ação"></Column>
          <Column field="idenAnalisePrograma" header="Ordem"></Column>
          <Column field="dataAnalisePrograma" header="Data"></Column>
          <Column field="contaAcesso.pessoa.nomePessoa" header="Analista Responsável SEPLAG"></Column>
          <Column field="descAnalisePrograma" header="Análise"></Column>
        </DataTable>
      </Panel>
      {visibleModal && (
        <ModalAnaliseGeralSeplag
          visibleModal={visibleModal}
          setVisibleModal={setVisibleModal}
          actionModal={actionModal}
          setActionModal={setActionModal}
          setAtualizarData={setAtualizarData}
          dataRow={dataRow}
          dadosItemPrograma={dadosItemPrograma}
        />
      )}
    </>
  );
};
export default AnaliseGeralSeplag;
